import { useState, useEffect } from 'react';
import { Routes, useNavigate, Route } from 'react-router-dom';
// import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
// import { LocalizationProvider } from '@mui/x-date-pickers';
import ProfileController from '@/services/ProfileController';
import useStore from '@/store/store';
import http from '@/services/http';
import { useWebPush } from '@/utils/useWebPush';

import HeaderPanel from '@/layout/header-panel/HeaderPanel';
import { getRoutesBasedOnPermissions } from './getRoutesBasedOnPermissions';
import { useSocketStore } from '@/store/socket.store';
import { RoutesNames } from './navigationRoutes';
import { lazyWithSuspense } from '@/shared/lazyWithSuspense';

const PageTerms = lazyWithSuspense(() => import('@/pages/Page-Terms'), null, null);
const PageAreas = lazyWithSuspense(() => import('@/pages/Page-Areas'), null, null);
const PageOrder = lazyWithSuspense(() => import('@/pages/Page-Order'), null, null);
const PagePrivacy = lazyWithSuspense(() => import('@/pages/Page-Privacy'), null, null);
const PageHome3D = lazyWithSuspense(() => import('@/pages/Page-Home3D'), null, null);

const Router = () => {
	const [loadingInit, setLoadingInit] = useState(true);

	const { user, login, setUser, setActiveOrders, setDraftOrders, resetAll } = useStore();
	//   const login = useStore((state) => state.login);
	//   const setUserEmpty = useStore((state) => state.setUserEmpty);

	//   const storeLogout = useStore((state) => state.logout);
	// const router = useRouter();
	const navigate = useNavigate();

	useWebPush();

	useEffect(() => {
		if (!user) {
			const { socket } = useSocketStore.getState();
			if (socket) {
				socket.disconnect();
			}
		}
	}, [user]);

	// cleanup orders gia na min exo flash me tis palies otan anoigo tin selida
	useEffect(() => {
		const handleUnload = () => {
			setActiveOrders(null);
			setDraftOrders(null);
		};

		window.addEventListener('beforeunload', handleUnload);

		return () => {
			window.removeEventListener('beforeunload', handleUnload);
		};
	}, []);

	// console.log("user", user);

	// TODO auto xreiazetai afou exoume react-router?
	const logout = () => {
		// storeLogout();
		// Must clear the token too: this is the forced-logout path for an invalid
		// token (code 91), and leaving it in localStorage re-triggers on every reload.
		localStorage.removeItem('token');
		resetAll();
		// router.replace("/");
		navigate('/', { replace: true });
	};

	const updateFavicon = faviconUrl => {
		let linkElement = document.querySelector("link[rel~='icon']");
		if (!linkElement) {
			// If the favicon link element doesn't exist, create it
			linkElement = document.createElement('link');
			linkElement.rel = 'icon';
			document.head.appendChild(linkElement);
		}
		linkElement.href = faviconUrl; // Update the favicon URL
	};

	const getFaviconFromUrl = url => {
		// Customize this logic based on your needs
		return url.includes('solvd') ? '/favicon_solvd.ico' : '/favicon.ico';
	};

	useEffect(() => {
		// Ensure this runs only on the client side
		if (typeof window !== 'undefined') {
			const faviconUrl = getFaviconFromUrl(window.location.href);
			updateFavicon(faviconUrl); // Update the favicon dynamically
		}
	}, []); // Empty dependency array ensures this runs only once on mount

	// Function to update the favicon dynamically

	useEffect(() => {
		http.setLogout(logout);
	}, [logout]);

	useEffect(() => {
		const getProfile = async () => {
			const token = localStorage.getItem('token');
			if (!token) {
				resetAll();
				setLoadingInit(false);
				return;
			}
			try {
				const res = await ProfileController.get();
				if (res?.profile) {
					// console.log("profile: ", res.profile);
					// if (window?.drift) {
					//   // console.log("reee s profile drift ", res.profile);
					//   const name = res?.profile?.name;

					//   if (showDrift) {
					//     drift.identify(`${res.profile?.id}`, {
					//       // email: name,
					//       first_name: name,
					//       name: name,
					//     });
					//   }
					// }

					login(res.profile);
				}
				setLoadingInit(false);
			} catch (error) {
				console.log(error);
				setLoadingInit(false);
			}
		};

		getProfile();
	}, [login, setUser]);

	return (
		<div className='app-container'>
			{!loadingInit && (
				<>
					<HeaderPanel />
					<Routes>
						{getRoutesBasedOnPermissions(user)}
						<Route path={RoutesNames.TERMS} element={<PageTerms />} />
						<Route path={RoutesNames.AREAS} element={<PageAreas />} />
						<Route path={RoutesNames.ORDER} element={<PageOrder />} />
						<Route path={RoutesNames.PRIVACY} element={<PagePrivacy />} />
						<Route path={RoutesNames.HOME_3D} element={<PageHome3D />} />
					</Routes>
				</>
			)}
		</div>
	);
};

export default Router;
